"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The B2B membership tiers.
 *
 * @category B2BMembership
 */
var B2BMembershipTiers;
(function (B2BMembershipTiers) {
    B2BMembershipTiers["CORE"] = "core";
    B2BMembershipTiers["ESSENTIALS"] = "essentials";
    B2BMembershipTiers["LEAD"] = "lead";
    B2BMembershipTiers["ADVANCE"] = "advance";
    B2BMembershipTiers["PRE_MEMBERSHIP"] = "pre-membership";
    B2BMembershipTiers["PRE_CANDIDATE"] = "pre-candidate";
    B2BMembershipTiers["VOTING"] = "voting";
    B2BMembershipTiers["VOTING_GRATIS_HONORARY"] = "voting-gratis-honorary";
    B2BMembershipTiers["NON_VOTING"] = "non-voting";
})(B2BMembershipTiers = exports.B2BMembershipTiers || (exports.B2BMembershipTiers = {}));
exports.B2BMembershipTiersArray = [
    B2BMembershipTiers.CORE,
    B2BMembershipTiers.ESSENTIALS,
    B2BMembershipTiers.LEAD,
    B2BMembershipTiers.ADVANCE,
    B2BMembershipTiers.PRE_MEMBERSHIP,
    B2BMembershipTiers.VOTING_GRATIS_HONORARY,
    B2BMembershipTiers.NON_VOTING,
];
/**
 * The B2B membership types available
 *
 * @category B2BMembership
 */
var B2BMembershipTypes;
(function (B2BMembershipTypes) {
    B2BMembershipTypes["REGULAR"] = "aicpa-membership-regular";
    B2BMembershipTypes["CANDIDATE"] = "aicpa-membership-candidate";
    B2BMembershipTypes["AFFILIATE"] = "aicpa-membership-affiliate";
    B2BMembershipTypes["RETIRED"] = "aicpa-membership-retired";
    B2BMembershipTypes["PRE_CANDIDATE"] = "pre-candidate";
    B2BMembershipTypes["INTERNATIONAL_ASSOCIATE"] = "aicpa-membership-international-associate";
    B2BMembershipTypes["STUDENT_AFFILIATE"] = "aicpa-membership-student-affiliate";
})(B2BMembershipTypes = exports.B2BMembershipTypes || (exports.B2BMembershipTypes = {}));
exports.B2BMembershipTypesArray = [
    B2BMembershipTypes.REGULAR,
    B2BMembershipTypes.CANDIDATE,
    B2BMembershipTypes.AFFILIATE,
    B2BMembershipTypes.RETIRED,
    B2BMembershipTypes.PRE_CANDIDATE,
    B2BMembershipTypes.INTERNATIONAL_ASSOCIATE,
];
//# sourceMappingURL=b2b-membership-types-tiers.js.map